import { SxProps, Theme } from '@mui/material';

/** Outer shell for the event cell; holds absolute WAITING badge */
export const eventShellSx: SxProps<Theme> = {
  position: 'relative',
  width: '100%',
  height: '100%',
};

export const eventRootSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: 0.5,
  margin: '4px 0',
};

export const statusBannerSx = (backgroundColor: string): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor,
  padding: 0.5,
  borderRadius: 1,
});

export const statusLabelTypographySx = (backgroundColor: string): SxProps<Theme> => (theme: Theme) => ({
  fontSize: '0.6rem',
  fontWeight: 'bold',
  color: theme.palette.getContrastText(backgroundColor),
});

export const companyRowBoxSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

export const companyNameTypographySx = (backgroundColor: string): SxProps<Theme> => (theme: Theme) => ({
  lineHeight: 1.2,
  color: theme.palette.getContrastText(backgroundColor),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const chipsRowBoxSx: SxProps<Theme> = {
  padding: 0.5,
  borderRadius: 1,
  flexWrap: 'wrap',
  gap: 0.5,
  display: 'flex',
  justifyContent: 'space-between',
};

export const engagementChipOuterSx = (backgroundColor: string, foregroundColor: string): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor,
  color: foregroundColor,
  padding: 0.5,
  borderRadius: 1,
});

export const engagementChipTextSx = (foregroundColor: string): SxProps<Theme> => ({
  fontSize: '0.7rem',
  color: foregroundColor,
});

export const labelChipOuterSx = (labelBackground: string): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: labelBackground,
  padding: 0.5,
  borderRadius: 1,
});

export const labelChipTextSx = (foregroundColor: string): SxProps<Theme> => ({
  fontSize: '0.7rem',
  color: foregroundColor,
});

export const notesTooltipContentSx: SxProps<Theme> = {
  maxWidth: 320,
  backgroundColor: '#333333',
  padding: 1,
  borderRadius: 1,
};

export const notesTooltipAuthorTypographySx: SxProps<Theme> = {
  color: 'white',
  display: 'block',
};

export const notesTooltipBodyTypographySx: SxProps<Theme> = {
  color: 'white',
  mt: 0.5,
  '& p': { m: 0 },
  '& ul, & ol': { my: 0, pl: 2 },
};

export const notesCountChipSx = (labelBackground: string): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  backgroundColor: labelBackground,
  padding: 0.5,
  borderRadius: 1,
});

export const notesCountIconSx = (foregroundColor: string): SxProps<Theme> => ({
  color: foregroundColor,
  fontSize: '1rem',
});

export const notesCountTextSx = (foregroundColor: string): SxProps<Theme> => ({
  fontSize: '0.7rem',
  color: foregroundColor,
});

export const peopleRowBoxSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};

export const peopleGroupBoxSx: SxProps<Theme> = {
  display: 'flex',
  gap: 0.5,
};

export const personAvatarDimensionsSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  fontSize: '1rem',
  fontWeight: 'bolder',
};

export const waitingBadgeBoxSx = (waitingBackgroundColor: string): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: waitingBackgroundColor,
  padding: 0.5,
  borderRadius: 1,
  position: 'absolute',
  bottom: 0,
  width: '50%',
  textAlign: 'center',
  transform: 'translateY(4px) translateX(50%)',
});
